import { getDisplaySize } from "../../../utils/Items";
import genmincho from '../../../font/SourceHanSerif-Medium_extracted.otf'
import genmincho_bold from '../../../font/SourceHanSerif-Bold_extracted.otf'
import { PageSizes } from "pdf-lib";
import { X_ALIGN_CENTER, Y_ALIGN_CENTER } from "../pdfUtil/drawTextInBox";

export const createSupplyPdfPageProperties = async (pdfDoc, printSetting) => {
  //日本語フォント読込
  const mincho_font = await pdfDoc.embedFont(await (await fetch(genmincho)).arrayBuffer());
  const mincho_bold_font = await pdfDoc.embedFont(await (await fetch(genmincho_bold)).arrayBuffer());

  const margin = 20;

  // サイズ
  const [ width, height ] = PageSizes.A4

  const tableColumns= [
    {
      name: 'originName',
      label: '産地', 
      widthWeight: 1,
      getValue: (data) => data?.originName,
      enabledOmit: true,
    },
    {
      name: 'productName',
      label: '品名',
      widthWeight: 3,
      getValue: (data) => data?.productName,
      enabledOmit: true,
      textOption: {font: mincho_bold_font, size: 15}
    },
    {
      name: 'rankClassName',
      label: '等階級',
      widthWeight: 2,
      getValue: (data) =>
        getDisplaySize(
          data?.rankName, data?.productClassName, data?.weight, data?.weightUnitName, data?.packingName, data?.otherSpec
        ),
      enabledOmit: true
    },
    {
      name: 'quantity',
      label: '数量',
      widthWeight: 2,
      getValue: (data) => getSupplyQuantity(data),
      enabledOmit: false,
      textOption: {size: 15}
    },
    {
      name: 'remarks',
      label: '備考',
      widthWeight: 2,
      getValue: (data) => data?.remarks,
      enabledOmit: false
    },
  ];

  return {
    ...printSetting,
    width,
    height,
    margin,
    headerHeight: 60,
    rowNumber: 23,
    columns: tableColumns,
    fonts : {
      mincho_font,
      mincho_bold_font
    }    
  }
};

const getSupplyQuantity = (data) => (
    (data.supplyUnitQuantity && data.supplyUnitQuantity > 0 ? data.supplyUnitQuantity.toString() + " × ": "")
      + data.supplyQuantity.toString()
);

